<template>
  <o-view>
    <o-view>
      <o-nav-bar title="Personal Information" :has-back-button="true" />
      <o-section> <o-text-input value="Jan" label="First Name" /> </o-section>
      <o-section>
        <o-text-input value="Declercq" label="Last Name" />
      </o-section>
      <o-section>
        <o-text-input value="+32 485 12 34 56" label="Phone Number" />
      </o-section>
      <o-section>
        <o-text-input
          value="jandeclercq@mailprovider.com"
          label="Email Address"
        />
      </o-section>
      <o-section>
        <o-text-input
          value="1991-02-26"
          type="date"
          icon="date"
          label="Birth Date"
        />
      </o-section>
    </o-view>
    <o-pay-button label="Save" @click="goBack" />
  </o-view>
</template>

<script>
import OPayButton from '@/components/OPayButton.vue'
export default {
  components: {
    OPayButton
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
